import { registerComponent } from "helpers";
import WYATTElement from "wyatt";

registerComponent(
  "preferred-store-name",
  class PreferredStoreName extends WYATTElement {
    constructor() {
      super();

      this.name = this.querySelector("[data-name]");
    }

    connectedCallback() {
      this.subscribe(
        WYATT.PubSub.events.preferredStoreSet,
        this.handlePreferredStoreSet.bind(this),
      );
    }

    handlePreferredStoreSet(store) {
      if (!store) {
        return;
      }

      if (!store.name) {
        return;
      }

      this.name.textContent = store.name;
    }
  },
);
